<template>
  <div class="proposal-user-info__content" v-if="currentProposal">
    <div class="proposal-user-info__content__title">
      <r-title type="subtitle-1">
        {{ $t("proposal-user-info.settings") }}
      </r-title>
    </div>
    <div class="proposal-user-info__content__block">
      <div
        class="proposal-user-info__content__block-row"
        v-for="field in proposalFields"
        :key="field.id"
      >
        <input-rendered
          :proposal="currentProposal"
          :field="field"
          :disabled="isDisabled"
        />
      </div>
    </div>
  </div>
</template>

<script>
import inputRendered from "./renderer/input-renderer";
import { proposalFields } from "./configs/index";
import { notifyFactory } from "@/utils";

import cloneDeep from "lodash.clonedeep";
import isEqual from "lodash.isequal";

export default {
  props: {
    proposal: {
      type: Object,
      required: true,
      default: () => null
    }
  },
  components: { inputRendered },
  data() {
    return {
      hasChanges: false,
      currentProposal: null,
      proposalFields
    };
  },
  watch: {
    proposal: {
      handler: function(val) {
        this.currentProposal = cloneDeep(val);
      },
      deep: true
    },
    currentProposal: {
      handler: function() {
        this.checkChanges();
      },
      deep: true
    },
    needDiscardChanges: {
      handler: function(val) {
        if (!val) return;
        this.discardChanges();
      },
      deep: true
    },
    isAllFieldsFilled: {
      handler: function(val) {
        this.$store.commit("SET_PROPOSAL_IS_ALL_FIELDS_FILED", val);
      },
      deep: true
    },
    saveHandler: {
      handler: function(val) {
        if (!val) return;
        this.saveProposal();
      },
      deep: true
    }
  },
  computed: {
    needDiscardChanges() {
      return this.$store.state.proposal.discardChanges;
    },
    isAllFieldsFilled() {
      if (!this.currentProposal) return false;
      const {
        name,
        email,
        first_name,
        last_name,
        company
      } = this.currentProposal;
      return name && email && first_name && last_name && company;
    },
    saveHandler() {
      return this.$store.state.proposal.saveHandler;
    },
    isDisabled() {
      return this.proposal.accepted;
    }
  },
  methods: {
    checkChanges() {
      const hasChanges = !isEqual(this.proposal, this.currentProposal);

      this.$store.commit("SET_PROPOSAL_HAS_CHANGES", hasChanges);
    },
    discardChanges() {
      this.currentProposal = cloneDeep(this.proposal);
      this.$store.commit("SET_PROPOSAL_DISCARD_CHANGES", false);
    },
    async saveProposal() {
      const dataUserObj = {
        email: this.currentProposal.email,
        first_name: this.currentProposal.first_name,
        last_name: this.currentProposal.last_name,
        middle_name: this.currentProposal.middle_name,
        id: this.currentProposal.id,
        company: this.currentProposal.company,
        position: this.currentProposal.position,
        name: this.currentProposal.name,
        valid_until: this.currentProposal.valid_until
      };

      try {
        this.$store.commit("SET_PROPOSAL_IS_LOADING", true);
        await this.$store.dispatch("POST_REQUEST", {
          url: `proposal?act=accept`,
          data: dataUserObj
        });
        const title = this.$t("notify-accept-title");
        const message = this.$t("notify-accept-text");
        this.$notify(notifyFactory("success", title, message));
        this.$store.commit("SET_PROPOSAL_ACCEPT_PROPOSAL", false);
        this.$store.commit("SET_PROPOSAL_UPDATE", true);
        this.$store.commit("SET_PROPOSAL_IS_LOADING", false);
      } catch (e) {
        if (
          e.response.data.error ===
          "Validation failed: Email has already been taken"
        ) {
          const title = this.$t("notify-error-title");
          const message = this.$t("notify-error-text");
          this.$notify(notifyFactory("error", title, message, 5000));
        }
        this.$store.commit("SET_PROPOSAL_ACCEPT_PROPOSAL", false);
        this.$store.commit("SET_PROPOSAL_IS_LOADING", false);
      }
    }
  },
  created() {
    this.currentProposal = cloneDeep(this.proposal);
  }
};
</script>

<style lang="scss" scoped>
.proposal-user-info__content {
  width: 520px;
  height: calc(100vh - 92px);
  position: relative;
  overflow: hidden;
  overflow-y: auto;
  padding: 20px 20px 0;
  &__title {
    margin-bottom: 12px;
  }
  &__block {
    margin-bottom: 28px;
    width: 100%;
    border: 1px solid;
    border-radius: var(--border-radius);
    padding: 24px;
    box-sizing: border-box;
    border-color: var(--dividers_low_contrast) !important;
    &-row {
      margin-bottom: 12px;
      &:last-child {
        margin-bottom: 0;
      }
      &__controls {
        text-align: end;
      }
    }
  }
  .r-date-picker {
    width: 100% !important;
  }
}
</style>

<i18n>
{
  "ru": {
    "proposal-user-info": {
      "settings": "Настройки"
    },
    "notify-accept-title": "Уведомление",
    "notify-accept-text": "Демо пользователь успешно создан",
    "notify-error-title": "Ошибка",
    "notify-error-text": "Пользователь с таким email уже существует"
  },
  "en": {
    "proposal-user-info": {
      "settings": "Settings"
    },
    "notify-accept-title": "Notification",
    "notify-accept-text": "Demo user successful created",
    "notify-error-title": "Error",
    "notify-error-text": "A user with the same email already exists"
  }
}
</i18n>
